export default {
  name: "PatchNotes",
  path: "/patch-notes",
  component: () => import("@/views/PatchNotes")
};
